module.exports = __webpack_public_path__ + "media/images/al-izza-grey-52927918541c7f894455c44904bac9d9.png";